// Proceduralne sprite'y postaci i zombie (placeholder do czasu atlasów graficznych z Etapu 4).
// Każdy ma klucz tekstury = kod potwora / "player", więc podmiana na prawdziwe grafiki nie zmienia logiki.
import Phaser from 'phaser';

interface Look { body: string; head: string; scale: number; hunch?: number; glow?: string }

const LOOKS: Record<string, Look> = {
  player: { body: '#3f5f7a', head: '#d8b48c', scale: 1 },
  player_self: { body: '#b5813a', head: '#d8b48c', scale: 1 },
  zombie_walker: { body: '#4b5a3c', head: '#8fa07a', scale: 1, hunch: 3 },
  zombie_runner: { body: '#5a4b3c', head: '#9aa57d', scale: 0.95, hunch: 5 },
  zombie_worker: { body: '#5e5a3a', head: '#8fa07a', scale: 1.08, hunch: 2 },
  zombie_armored: { body: '#2c3542', head: '#7d8a70', scale: 1.12, hunch: 1 },
  zombie_soldier: { body: '#3c4a2e', head: '#7d8a70', scale: 1.08, hunch: 2 },
  zombie_chemical: { body: '#6a6a2a', head: '#a4b04f', scale: 1, hunch: 3, glow: '#c8d84a' },
  zombie_toxic: { body: '#3a5a3a', head: '#7fb07a', scale: 1, hunch: 3, glow: '#6fd86a' },
  zombie_screamer: { body: '#5a3a4a', head: '#b09aa0', scale: 0.92, hunch: 1 },
  zombie_mutant: { body: '#5a2c2c', head: '#a07070', scale: 1.3, hunch: 6 },
  zombie_giant: { body: '#4a3030', head: '#8a6a6a', scale: 1.9, hunch: 4 },
  zombie_elite: { body: '#1e1e24', head: '#c0c0c8', scale: 1.15, hunch: 0, glow: '#c2412d' },
  zombie_drowned: { body: '#2c4a52', head: '#7a9aa0', scale: 1, hunch: 3 },
  npc: { body: '#6a5a8a', head: '#d8b48c', scale: 1 },
};

export function makeCharacterTextures(scene: Phaser.Scene): void {
  for (const [key, look] of Object.entries(LOOKS)) {
    const w = Math.ceil(28 * look.scale), h = Math.ceil(48 * look.scale);
    const tex = scene.textures.createCanvas(`ch-${key}`, w, h)!;
    const c = tex.getContext();
    c.scale(look.scale, look.scale);
    c.fillStyle = 'rgba(0,0,0,0.35)';
    c.beginPath(); c.ellipse(14, 44, 10, 4, 0, 0, Math.PI * 2); c.fill();
    const hunch = look.hunch ?? 0;
    c.fillStyle = '#1b1b1b'; c.fillRect(9, 30, 4, 13); c.fillRect(15, 30, 4, 13);
    c.fillStyle = look.body; c.fillRect(7 + hunch * 0.3, 15, 14, 17);
    c.fillRect(4 + hunch, 17, 3, 11); c.fillRect(21 + hunch, 17, 3, 11);
    c.fillStyle = look.head; c.beginPath(); c.arc(14 + hunch, 10, 6, 0, Math.PI * 2); c.fill();
    if (look.glow) { c.fillStyle = look.glow; c.fillRect(11 + hunch, 9, 2, 2); c.fillRect(15 + hunch, 9, 2, 2); }
    tex.refresh();
  }
}

export function textureFor(scene: Phaser.Scene, code: string): string {
  const k = `ch-${code}`;
  return scene.textures.exists(k) ? k : (code.startsWith('zombie') ? 'ch-zombie_walker' : 'ch-player');
}
